import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { deserialize } from 'santee-dcts';
import { Observable } from 'rxjs';

import { UserProfilesSearchParams } from './user-profiles-search-params';
import { UserProfilesReadModel } from './user-profiles-readmodel';
import { Settings } from '../../core';

@Injectable()
export class UserProfilesStorage {

    constructor(
        private http: HttpClient,
        private settings: Settings
    ) { }

    public loadPageOfUsers(searchParams: UserProfilesSearchParams): Observable<UserProfilesReadModel> {
        let httpSearchParams = new HttpParams();
        httpSearchParams = httpSearchParams.append('FirstName', searchParams.firstName || '');
        httpSearchParams = httpSearchParams.append('LastName', searchParams.lastName || '');
        httpSearchParams = httpSearchParams.append('UserName', searchParams.userName || '');
        httpSearchParams = httpSearchParams.append('Page', searchParams.page.toString());

        return this.http.get(`${this.settings.apiUrl}/admin/user-profiles/search`, { params: httpSearchParams })
            .pipe(
                map((response) => deserialize(response, UserProfilesReadModel)),
            ) as Observable<UserProfilesReadModel>;
    }
}